<div class="wizard-body" [class.separator]="separator">
  <ng-content select="ui-booking-wizard-body-column"></ng-content>
</div>
